import React from 'react'
import createReactClass from 'create-react-class'
import {Tab, Tabs, TabList, TabPanel} from 'react-tabs'
import SearchPanel from '../../containers/search/search-panel-container'
import MonitoringPanel from '../../containers/monitoring-panel-container'
import ViewURLPanel from '../view-url-button/view-url-panel'

export default createReactClass({
  changeTab (tabIndex) {
    this.props.changeActiveTab(tabIndex)
  },
  render () {
    return (
      <div className='container search-type-panel'>
        <div>
          <Tabs selectedIndex={this.props.activeTab} onSelect={(tabIndex) => this.changeTab(tabIndex)}>
            <TabList>
              <Tab>Search</Tab>
              <Tab>Monitoring</Tab>
            </TabList>
            <TabPanel>
              <SearchPanel history={this.props.history} {...this.props.search}/>
            </TabPanel>
            <TabPanel>
              <MonitoringPanel history={this.props.history} {...this.props.monitoring}/>
            </TabPanel>
          </Tabs>
        </div>
        <ViewURLPanel/>
      </div>
    )
  },
})



// WEBPACK FOOTER //
// ./src/components/search-page/search-type-panel.js